<template>
  <div class="plan-row-item-ft" @click="startFreeTrialHandler(plan)">
    <div class="plan-row-item-ft__promo-banner" v-if="hasPromoBanner">
      Full Access to INE's entire course library
    </div>
    <div class="plan-row-item-ft__title">
      {{ plan.name }}
    </div>
    <div class="plan-row-item-ft__price">
      FREE
      <span class="plan-row-item-ft__price-term">7 Day risk free trial *</span>
    </div>
    <div class="plan-row-item-ft__details">
      <PlanListItemDetails :plan="plan" />
    </div>
    <button
      @click="startFreeTrialHandler(plan)"
      class="btn btn--secondary plan-row-item-ft__btn-start-trial"
    >
      Start Trial
    </button>
    <div class="plan-row-item-ft__price-clarification">
      {{ `*Then $${price} per ${plan.term}, billed ${billingTypeString(plan.term)}.` }}
    </div>
  </div>
</template>

<script>
import PlanListItemDetails from '@/components/PlanListItemDetails.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'PlanRowItemFreeTrialCard',
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
  components: {
    PlanListItemDetails,
  },
  computed: {
    hasPromoBanner() {
      return this.plan.merchant_id === CONSTANTS.PLANS.PREMIUM
    },
    price() {
      return this.plan.price_cents / 100
    },
  },
  methods: {
    startFreeTrialHandler(plan) {
      this.$emit('start-free-trial-plan', plan)
    },
    billingTypeString(type) {
      return type === 'month' ? 'monthly' : 'annually'
    },
  },
}
</script>

<style lang="scss">
.plan-row-item-ft {
  background: var(--mid-gray-gradient);
  border-radius: 10px;
  padding: 20px 30px;
  position: relative;
  transition: all 1s ease-out;
  width: 100%;
  cursor: pointer;
  @include mobile {
    width: 50%;
  }
  @include desktop {
    width: 340px;
  }
  &:hover {
    background: var(--mid-gray-translucid-gradient);
  }
  &:active {
    transition: all 0.5s ease-out;
    background: var(--charcoal-gradient-two);
  }
  &__title {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    margin-top: 25px;
    @media screen and (max-width: 1236px) {
      font-size: 18px;
      line-height: 24px;
    }
    @include tablet-ipad-air-and-mini-portrait {
      width: 60%;
    }
  }
  &__price {
    font-weight: 700;
    font-size: 54px;
    line-height: 66px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--mid-gray-translucid);
    padding-bottom: 30px;
    margin-bottom: 30px;
    @include mobile {
      font-size: 40px;
      line-height: 52px;
      padding-bottom: 20px;
      margin-bottom: 20px;
    }
    @include desktop {
      font-size: 54px;
      line-height: 66px;
      padding-bottom: 40px;
      margin-bottom: 40px;
    }
    &-term {
      font-weight: 450;
      font-size: 12px;
      line-height: 14px;
      margin-left: 5px;
      width: 65px;
      color: var(--dusty-gray);
    }
  }
  &__details {
    margin-bottom: 20px;
  }
  &__promo-banner {
    background: var(--purple-gradient);
    position: absolute;
    width: 100%;
    float: left;
    top: 0;
    left: 0;
    border-radius: 10px 10px 0 0;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 450;
    font-size: 12px;
    line-height: 14px;
  }
  &__price-clarification {
    background: var(--mid-gray-translucid-gradient-two);
    color: var(--dusty-gray);
    position: absolute;
    width: 100%;
    float: left;
    bottom: 0;
    left: 0;
    border-radius: 0 0 10px 10px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 450;
    font-size: 12px;
    line-height: 14px;
  }
  &__btn-start-trial {
    margin-bottom: 35px;
    width: 100%;
    @include desktop {
      margin-bottom: 55px;
    }
  }
}
</style>
